'use client';

import { forwardRef, useEffect, useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '@/lib/hooks/useCart';
import { cn } from '@/lib/utils';

interface CartButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const CartButton = forwardRef<HTMLButtonElement, CartButtonProps>(
  ({ className, ...props }, ref) => {
    const { cart } = useCart();
    const [itemCount, setItemCount] = useState(0);

    useEffect(() => {
      const count = cart?.items?.reduce((sum, item) => sum + item.quantity, 0) ?? 0;
      setItemCount(count);
    }, [cart]);

    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          "relative inline-flex items-center justify-center rounded-md border bg-background h-10 w-10 hover:bg-primary/10",
          className
        )}
        {...props}
      >
        <ShoppingCart className="h-5 w-5" />
        {itemCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-primary text-primary-foreground text-xs rounded-full h-5 w-5 flex items-center justify-center">
            {itemCount}
          </span>
        )}
      </button>
    );
  }
);

CartButton.displayName = 'CartButton'; 